import * as React from 'react'
import { useAuthenticatedUser } from '@components/hooks/use-authenticated-user'
import { useNavigate } from 'react-router-dom'
import { NavigationPath } from '@models/routes'
import { TechnicalOrderStatus } from '@models/technical-orders'

export const TechnicalOrdersDefaultView: React.FC = () => {
  const user = useAuthenticatedUser()

  const resort = user.resorts[0]
  const navigate = useNavigate()

  React.useEffect(() => {
    navigate(
      NavigationPath.TechnicalOrdersWithParams.replace(':resort_id', String(resort.id)).replace(
        ':type',
        String('todo' as TechnicalOrderStatus),
      ),
    )
  }, [resort])

  return null
}
